
/**
 * Definition of Mercado Pago gateway.
 * @typedef {Object} Gateway
 */
const mercadopago = {
  id: 'mercadopago',
  allowReusableUse: false,
  allowSingleUse: true,
  currencies: ['CLP'],
  statusReasons: {
    pending_contingency: 'El pago está siendo procesado',
    pending_review_manual: 'El pago está en revisión para determinar su aprobación o rechazo',
    cc_rejected_bad_filled_date: 'Fecha de vencimiento incorrecta',
    cc_rejected_bad_filled_other: 'Datos de la tarjeta incorrectos',
    cc_rejected_bad_filled_security_code: 'CVV incorrecto',
    cc_rejected_blacklist: 'La tarjeta está en una lista negra por robo/quejas/fraude',
    cc_rejected_call_for_authorize: 'El medio de pago requiere autorización previa del monto de la operación',
    cc_rejected_card_disabled: 'La tarjeta está inactiva',
    cc_rejected_duplicated_payment: 'Transacción duplicada',
    cc_rejected_high_risk: 'Rechazo por Prevención de Fraude',
    cc_rejected_insufficient_amount: 'Monto insuficiente',
    cc_rejected_invalid_installments: 'Número de cuotas inválido',
    cc_rejected_max_attempts: 'Excedido el número máximo de intentos',
    cc_rejected_other_reason: 'Error genérico'
  },
  flow: 'none',
  name: 'Mercado Pago'
}

/**
 * Definition of Webpay gateway.
 * @typedef {Object} Gateway
 */
const webpay = {
  id: 'webpay',
  allowReusableUse: false,
  allowSingleUse: true,
  currencies: ['CLP'],
  flow: 'redirect',
  name: 'Webpay'
}

export default [
  {
    id: 'stripe',
    allowReusableUse: true,
    allowSingleUse: true,
    currencies: ['USD', 'MXN'],
    flow: 'none',
    name: 'Stripe',
    testMode: {
      publicKey: process.env.VUE_APP_STRIPE_PUBLIC_KEY,
      card: {
        number: '4242 4242 4242 4242',
        date: '12 / 25',
        cvv: '123'
      }
    }
  },
  {
    id: 'paypal',
    allowReusableUse: false,
    allowSingleUse: true,
    currencies: ['USD', 'MXN'],
    flow: 'redirect',
    name: 'PayPal'
  },
  {
    id: 'oneclick',
    allowReusableUse: true,
    allowSingleUse: false,
    currencies: ['CLP'],
    flow: 'redirect',
    name: 'OneClick Transbank'
  },
  {
    id: 'twocheckout',
    allowReusableUse: false,
    allowSingleUse: true,
    currencies: ['USD'],
    flow: 'none',
    title: '2Checkout'
  },
  mercadopago,
  webpay
]